import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Все, конечно, знают, что Музы давно умерли. 
        За тысячи лет они усохли, истлели и, как опавшие листья, выметены ветром истории. 
        Кто сейчас поклоняется Музам? 
        Они не нужны человечеству. 
      </p>
        
      <p class="mb-3">
        Но их мать, Мнемозина, только покрылась пылью истории. 
        О ней просто забыли: ведь для памяти не надо специального божества, она стала повседневной заурядностью. 
        Но вот пришло время, когда даже простая память стала опасной для тех, кто хочет править миром. 
        Им нужно абсолютное повиновение; а память подразумевает осознание опыта и логические выводы из него, т.е. самостоятельное мышление, независимость его. 
      </p>
        
      <p class="mb-3">
        Да не будет так! 
        И бедную дряхлую Мнемозину выволокли из её пыльной норы, поставили к стенке и быстренько расстреляли. 
      </p>
        
      <p class="mb-3">
        И с тех пор ничто в мире уже не могло остановить его будущих завоевателей. 
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: `Убийство Мнемозины`
}

const itemDate = {
  rus: `10 сентября 2023`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;